import themeUtils from '../themeUtils';

export default class DynamicCollectionsList {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.initializedClass = 'collection-initialized';
    this.$collectionsContainer = $('[data-collections]', this.$el);
    this.collectionHeight = this.el.querySelector('.home-collections').getBoundingClientRect().height;
    this._setupCollections = this._setupCollections.bind(this);
    this._bindEvents();
    this._setupCollections();
  }

  onSectionLoad() {
    this._bindEvents();
    this._setupCollections();
  }

  onSectionUnload() {
    this._unbindEvents();
  }

  onSectionBlockSelect(event) {
    this._setupCollections();
  }

  onSectionBlockDeselect(event) {
    this._setupCollections();
  }

  _bindEvents() {
    $('.home-collection-overlay-wrapper').on('click', event => this._redirectCollection);
    this.$el.on('rimg:load', () => {
      this._setupCollections();
    });
    $(window).on('resize.collections-view', themeUtils.debounce(this._setupCollections, 500));
  }

  _unbindEvents() {
    $('.home-collection-overlay-wrapper').off('click');
    $(window).off('resize.collections-view');
  }

  _setupCollections() {
    const featuredCollectionImages = this.el.querySelectorAll('.home-collection-image img, .home-collection-image svg');

    $.each(featuredCollectionImages, (index, collectionImage) => {
      const collectionImageHeight = collectionImage.getBoundingClientRect().height;

      $(collectionImage).css({ height: 'auto' });

      if (collectionImageHeight > 0) {
        this.collectionHeight = collectionImage.getBoundingClientRect().height;
      }
    });

    $(featuredCollectionImages).css({ height: '' });
    this.$el.find('.home-collection-image').height(this.collectionHeight);
  }

  _redirectCollection(e) {
    const $currentTarget = $(e.currentTarget);

    if (!$currentTarget.parents(this.$collectionsContainer).length) return;

    const url = $currentTarget.data('url');

    if (url !== '') {
      window.location = url;
    }
  }
}
